<!-- Footer.svelte -->
<script>
import Constantes from '../Classes/Constantes.js';
export let version = Constantes.versao; 
  </script>
  
  <style>
    .footer {
      background-color: #cbd4fd;
      bottom: 0; /* Alinha a barra inferior ao final da tela */
      left: 0; /* Alinha a barra inferior à esquerda */
      border-top: 2px solid #3659FC; /* Adiciona uma borda superior */
      color: #3659FC;
      display: flex;
      justify-content: space-between;
      padding: 10px 20px;
      font-weight: bold;
      align-items: center;
      width: 100%; /* Largura da tela inteira */
      position: fixed; /* Fixa a barra inferior na parte inferior da tela */
      bottom: 0; /* Alinha a barra inferior ao final da tela */
      left: 0; /* Alinha a barra inferior à esquerda */
      
    }
  
    .logo {
      width: 40px; /* Ajuste a largura conforme necessário */
    }
  </style>
  
  <div class="footer">
    <span>{version}</span>
    <img class="logo" src="./img/WODOXI_logo.png" alt="Logo">
  </div>